import request from '@/CommonDP/utils/request';

export default {
  // 显示列表
  personListTable(params) {
    return request.post(
      '/admin/enterprise/personnel/getPersonnelList',
      params
    );
  },
  // 项目列表
  getPrjLogList(params) {
    return request.get('/admin//log/project', { params });
  },
  // 新增
  newAddPerson(params) {
    return request
      .post(`/admin/user/saveUser`, params)
      .then((res) => res);
  },
  // 修改
  newEditPerson(params) {
    return request
      .post(`/admin/enterprise/personnel/update`, params)
      .then((res) => res);
  },
  // 详情
  detailPerson(enterpriseUserId) {
    return request
      .get(
        `/admin/enterprise/personnel/getPersonnelDetails?enterpriseUserId=${enterpriseUserId}`
      )
      .then((res) => res);
  },
  // 删除
  personnelmanagedelete(params) {
    return request
      .post(`/admin/enterprise/personnel/delete`, params)
      .then((res) => res);
  },
  // 系统日志---列表
  pageList(params) {
    return request.post(`/admin/log/system`, params).then((res) => res);
  },
  // 项目日志---列表
  projectList(params) {
    return request.post(`/admin/log/project`, params).then((res) => res);
  },
  queryPrj(prjName, enterpriseId) {
    return request
      .get(
        `/admin/project/getProjectsByUserId?prjName=${prjName}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  updateStatus(params) {
    return request.get(`/admin/api/v1auth/updateStatus`, { params });
  },
  // 重置密码
  providerResetPassword(params) {
    return request
      .post(`/admin/user/providerResetPassword`, undefined, { params })
      .then((res) => res);
  },
  updatePassword(params) {
    return request({
      method: 'post',
      url: '/admin/api/v1user/updatePassword',
      params
    });
  },
  prj_selectList(params) {
    return request.post('/admin/prj/selectList', { params });
  },

  generateInviteCode(enterpriseId, phone, isExternal) {
    return request
      .get(
        `/admin/enterprise/generateInviteCode?enterpriseId=${enterpriseId}&phone=${phone}&isExternal=${isExternal}`
      )
      .then((res) => res);
  },
  getNotJoinUserList(params) {
    return request
      .post(
        `/admin/enterprise/personnel/getNotJoinPersonnelList`,
        params
      )
      .then((res) => res);
  },
  enabled(enterpriseUserId, enabled) {
    return request
      .get(
        `/admin/enterprise/personnel/enabled?enterpriseUserId=${enterpriseUserId}&enabled=${enabled}`
      )
      .then((res) => res);
  },
  joinEnterpriseapproval(params) {
    return request.post(
      '/admin/enterprise/joinEnterprise/approval',
      params
    );
  },

  queryCommonUserInfo(userId) {
    return request(`/user/queryCommonUserInfo/${userId}`);
  },
  batchQueryCommonUserInfo(data) {
    return request.post(`user/batchQueryCommonUserInfo`, data);
  }

};
